var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFxLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.768 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 125,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.768 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.046 28.08c0 8.88-7.184 16.08-16.046 16.08-8.862 0-16.046-7.2-16.046-16.08C39.954 19.2 47.138 12 56 12c8.862 0 16.046 7.2 16.046 16.08Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.633 84c4.123 0 7.867-2.828 7.867-6.96 0-15.773-12.76-28.56-28.5-28.56S27.5 61.267 27.5 77.04c0 4.132 3.744 6.96 7.867 6.96h41.266Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.177 67.056C85.487 71.644 89.67 75 94.627 75c6.005 0 10.873-4.925 10.873-11s-4.868-11-10.874-11c-4.957 0-9.14 3.356-10.449 7.944H64.708c-.667 0-1.208.548-1.208 1.223v3.666c0 .675.54 1.223 1.208 1.223h1.813v1.833c0 .675.54 1.222 1.208 1.222h1.812c.667 0 1.208-.547 1.208-1.222v-1.833h4.229v1.833c0 .675.54 1.222 1.208 1.222h1.812c.668 0 1.209-.547 1.209-1.222v-1.833h4.97ZM89.19 64c0 3.037 2.434 5.5 5.437 5.5s5.437-2.463 5.437-5.5c0-3.038-2.434-5.5-5.437-5.5S89.19 60.962 89.19 64Z",
    fill: "url(#d)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m83.715 27.602.013-.006.013-.006c.457-.225.925-.255 1.473-.053 1.337.492 2.644.752 3.914.76h.026c1.334-.028 2.547-.413 3.606-1.165 1.137-.774 1.956-1.978 2.514-3.495.438-1.189.537-2.385.265-3.565-.237-1.148-.781-2.175-1.603-3.071-.807-.902-1.84-1.571-3.064-2.022a7.903 7.903 0 0 0-2.955-.497h-.014a9.093 9.093 0 0 0-2.758.546l-.007.002-.007.003c-.49.186-1.05.27-1.698.234-.353-.034-.724-.227-1.107-.805-.405-.623-.465-1.123-.34-1.568.122-.44.427-.824 1.087-1.127l.012-.005a11.163 11.163 0 0 1 4.392-1.079h.01c1.584-.08 3.147.162 4.697.733 1.947.716 3.502 1.797 4.696 3.232l.007.009.007.008c1.248 1.438 2.055 3.052 2.432 4.851.372 1.775.228 3.582-.458 5.444-.52 1.416-1.185 2.563-1.978 3.464a8.26 8.26 0 0 1-2.73 2.026 9.621 9.621 0 0 1-3.306.832 14.626 14.626 0 0 1-3.725-.267l-.149-.029-.527.058-.148.067a1.192 1.192 0 0 0-.617.683l-.618 1.677c-.203.553-.531.917-1 1.152-.44.199-.91.22-1.47.014-.56-.206-.902-.526-1.109-.963-.204-.483-.218-.973-.015-1.526l1.269-3.445c.205-.558.527-.897.97-1.1Zm-4.85 16.484c-.704-.26-1.063-.588-1.24-.92-.139-.347-.158-.828.098-1.524l.284-.77c.264-.72.592-1.04.896-1.18.36-.166.849-.201 1.556.06l.593.217c.711.262 1.027.595 1.165.918l.013.03.014.029c.158.312.208.764-.05 1.467l-.284.77c-.258.7-.599 1.044-.959 1.209-.305.14-.767.18-1.494-.088l-.593-.218Z",
    fill: "#D4DCE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 74.5,
    y1: 81.5,
    x2: 40.523,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 74.5,
    y1: 81.5,
    x2: 40.523,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 105.5,
    y1: 64,
    x2: 61.401,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A8189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxLoginIcon);
export default __webpack_public_path__ + "static/media/fx-login-icon.9d22993f67fb9a49de3e5f77be41b585.svg";
export { ForwardRef as ReactComponent };